'use client';

import { ArrowRight } from '@components/icons/ArrowRight';
import { SiteLocale } from '@graphql/generated';
import t from '@lib/locales';
import { usePathname } from 'next/navigation';

type IProps = {
  params: { lang: SiteLocale };
};

export const Account = ({ params }: IProps) => {
  const { lang } = params;
  const pathname = usePathname();
  return (
    <>
      <span className="header_section">
        <span className="header_section__text__text04">{t(lang, 'my_account')}</span>
      </span>

      <div className="item_account">
        <div className="item account_profile">
          <a href={`${pathname}/profile`} className="frame2">
            <div className="group2">
              <span className="item_account__text__text01">{t(lang, 'personal_data')}</span>
              <ArrowRight />
            </div>
            <span className="item_account__text">
              <span>{t(lang, 'modify_personal_data')}</span>
            </span>
          </a>
        </div>
        {process.env.MFE_MY_ACCOUNT_URL && (
          <div className="item account_orders">
            <a href={`${pathname}/orders`} className="frame2">
              <div className="group2">
                <span className="item_account__text__text01">
                  <span>{t(lang, 'my_orders')}</span>
                </span>
                <ArrowRight />
              </div>
              <span className="item_account__text">
                <span></span>
              </span>
            </a>
          </div>
        )}
        <div className="item account_shipping">
          <a href={`${pathname}/shipping`} className="frame2">
            <div className="group2">
              <span className="item_account__text__text01">
                <span>{t(lang, 'shipping_addresses')}</span>
              </span>
              <ArrowRight />
            </div>
            <span className="item_account__text">
              <span>{t(lang, 'modify_addresses_detail')}</span>
            </span>
          </a>
        </div>
        <div className="item account_billing">
          <a href={`${pathname}/billing`} className="frame2">
            <div className="group2">
              <span className="item_account__text__text01">
                <span>{t(lang, 'billing_addresses')}</span>
              </span>
              <ArrowRight />
            </div>
            <span className="item_account__text">
              <span>{t(lang, 'modify_billing_addresses')}</span>
            </span>
          </a>
        </div>
      </div>
    </>
  );
};
